class Wishlist {
  constructor() {
    this.storageKey = 'customerWishlist';
    this.init();
  }

  init() {
    // Update wishlist count on page load
    this.updateWishlistCount();

    // Add event listeners to wishlist buttons
    this.attachEventListeners();

    // Update button states based on wishlist
    this.updateButtonStates();
  }

  attachEventListeners() {
    // Collection page wishlist buttons
    document.querySelectorAll('.custom-product-card__wishlist-btn').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const productCard = button.closest('.custom-product-card');
        const productData = {
          id: productCard.dataset.productId,
          handle: productCard.dataset.productHandle,
          title: productCard.dataset.productTitle,
          price: productCard.dataset.productPrice,
          image: productCard.dataset.productImage
        };

        this.toggleWishlist(productData, button);
      });
    });
  }

  getWishlist() {
    try {
      const wishlist = localStorage.getItem(this.storageKey);
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (error) {
      console.error('Error reading wishlist:', error);
      return [];
    }
  }

  saveWishlist(wishlist) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
    } catch (error) {
      console.error('Error saving wishlist:', error);
    }
  }

  isInWishlist(productId) {
    const wishlist = this.getWishlist();
    return wishlist.some(item => item.id === productId);
  }

  addToWishlist(product) {
    const wishlist = this.getWishlist();

    if (!this.isInWishlist(product.id)) {
      wishlist.push(product);
      this.saveWishlist(wishlist);
      return true;
    }

    return false;
  }

  removeFromWishlist(productId) {
    let wishlist = this.getWishlist();
    wishlist = wishlist.filter(item => item.id !== productId);
    this.saveWishlist(wishlist);
  }

  toggleWishlist(product, button) {
    const isInWishlist = this.isInWishlist(product.id);

    if (isInWishlist) {
      this.removeFromWishlist(product.id);
      button.classList.remove('is-active');
    } else {
      this.addToWishlist(product);
      button.classList.add('is-active');
      this.animateWishlistBubble();
    }

    this.updateWishlistCount();
  }

  updateWishlistCount() {
    const wishlist = this.getWishlist();
    const count = wishlist.length;
    const countElement = document.getElementById('wishlist-count');
    const bubbleElement = document.getElementById('wishlist-bubble');
    const wishlistIcon = document.querySelector('.header-actions__wishlist-icon');

    if (countElement && bubbleElement) {
      countElement.textContent = count;

      if (count > 0) {
        bubbleElement.style.display = 'flex';
        wishlistIcon?.classList.add('header-actions__wishlist-icon--has-items');
      } else {
        bubbleElement.style.display = 'none';
        wishlistIcon?.classList.remove('header-actions__wishlist-icon--has-items');
      }
    }
  }

  updateButtonStates() {
    document.querySelectorAll('.custom-product-card__wishlist-btn').forEach(button => {
      const productId = button.dataset.productId;

      if (this.isInWishlist(productId)) {
        button.classList.add('is-active');
      } else {
        button.classList.remove('is-active');
      }
    });
  }

  animateWishlistBubble() {
    const bubbleElement = document.getElementById('wishlist-bubble');

    if (bubbleElement) {
      bubbleElement.classList.add('wishlist-bubble--animating');

      setTimeout(() => {
        bubbleElement.classList.remove('wishlist-bubble--animating');
      }, 300);
    }
  }

  renderWishlistPage() {
    const wishlist = this.getWishlist();
    const container = document.getElementById('wishlist-products-grid');

    if (!container) return;

    if (wishlist.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 80px; height: 80px; margin: 0 auto 20px; color: #ccc;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
          </svg>
          <h2>Your wishlist is empty</h2>
          <p>Start adding your favorite puzzles!</p>
          <a href="/collections/all" class="btn btn-primary">Shop Now</a>
        </div>
      `;
      return;
    }

    container.innerHTML = wishlist.map(product => `
      <div class="custom-product-card" data-product-id="${product.id}">
        <div class="custom-product-card__image-wrapper">
          <a href="/products/${product.handle}" class="custom-product-card__link">
            <img src="${product.image}" alt="${product.title}" class="custom-product-card__image" loading="lazy">
          </a>

          <button class="custom-product-card__wishlist-btn is-active" data-product-id="${product.id}" aria-label="Remove from wishlist">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
            </svg>
          </button>
        </div>

        <div class="custom-product-card__content">
          <h3 class="custom-product-card__title">
            <a href="/products/${product.handle}" class="custom-product-card__title-link">
              ${product.title}
            </a>
          </h3>

          <div class="custom-product-card__price">
            <span class="custom-product-card__price--regular">${product.price}</span>
          </div>
        </div>
      </div>
    `).join('');

    // Reattach event listeners for remove buttons
    this.attachWishlistPageListeners();
  }

  attachWishlistPageListeners() {
    document.querySelectorAll('#wishlist-products-grid .custom-product-card__wishlist-btn').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const productId = button.dataset.productId;
        this.removeFromWishlist(productId);
        this.updateWishlistCount();
        this.renderWishlistPage();
      });
    });
  }
}

// Initialize wishlist when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.wishlistManager = new Wishlist();

  // Render wishlist page if we're on it
  if (document.getElementById('wishlist-products-grid')) {
    window.wishlistManager.renderWishlistPage();
  }
});
